/* global angular */
( function () {
	'use strict';

	/* @ngInject */
	function saveTemplateMask ( apiService ) {
		function typeMapper ( tag ) {
			return tag.tagName;
		}

		function tagMapper ( tag ) {
			var newTag = {};

			newTag[ tag.filterName ] = tag.children.map( function ( child ) {
				return child.tagName;
			} );

			return newTag;
		}

		function subOptionMapper ( subOption, parent ) {
			subOption.id       = subOption.id || apiService.generateUUID();
			subOption.selected = false;
			subOption.type     = ( parent || {} ).type || subOption.type;

			if ( !subOption.value || subOption.value === '' ) {
				delete subOption.value;
			}

			delete subOption.answerId;
			delete subOption.presentationOrder;
			delete subOption.selectAll;
			delete subOption.tempValue;
			delete subOption.selected;
			delete subOption.redac;

			return subOption;
		}

		function answerOptionMapper ( indicator, answerOption ) {
			answerOption.type = answerOption.type || 2;

			subOptionMapper( answerOption );

			if ( answerOption.subOptions && answerOption.subOptions.length ) {
				answerOption.subOptions = answerOption.subOptions.map( function ( subOption ) {
					return subOptionMapper( subOption, answerOption );
				} );
			}

			delete answerOption.selected;

			return answerOption;
		}

		function attachmentsMapper ( attachments ) {
			// attachments.id   = attachments.ContentId;
			// attachments.name = attachments.ContentName;
			// attachments.type = attachments.type || 1;

			// delete attachments.ContentId;
			// delete attachments.ContentName;

			var filterAttachments = {
				'id'   : attachments.ContentId || attachments.id,
				'name' : attachments.ContentName || attachments.name,
				'type' : attachments.type || 1
			};

			return filterAttachments;
		}

		function indicatorMapper ( indicator ) {
			indicator.type = indicator.type.toString();

			indicator.templateAttachments = ( indicator.templateAttachments || [] ).map( attachmentsMapper );

			delete indicator.title;
			delete indicator.path;
			delete indicator.presentationOrder;
			delete indicator.answerText;
			delete indicator.selectAll;
			delete indicator.tempValue;
			delete indicator.score;
			delete indicator.redac;

			if ( indicator.answerOptions && indicator.answerOptions.length ) {
				indicator.answerOptions = indicator.answerOptions.map( function ( answerOption ) {
					return answerOptionMapper( indicator, answerOption );
				} );
			}

			return indicator;
		}

		function rubricMapper ( model ) {
			if ( !angular.isUndefined( model.rubric ) ) {
				var prevAnsOption = {
					'value' : -1
				};

				model.rubric = model.rubric.answerOptions.map( function ( answerOption ) {
					var newAnswerOptions = {
						'title'       : answerOption.optionText,
						'description' : answerOption.description,
						'minRange'    : prevAnsOption.value,
						'maxRange'    : answerOption.value
					};

					prevAnsOption = answerOption;
					return newAnswerOptions;
				} );
			}
		}

		function groupMapper ( group ) {
			var groupModel = {
				'name'                : group.groupName.trim(),
				'id'                  : group.id,
				'indicators'          : group.indicators.map( indicatorMapper ),
				'templateAttachments' : ( group.templateAttachments || [] ).map( attachmentsMapper )
			};

			if ( group.formula ) {
				groupModel.formula = group.formula;
			}

			if ( group.rubric ) {
				groupModel.rubric = group.rubric;
			}

			rubricMapper( groupModel );

			return groupModel;
		}

		// TODO - API still too volatile, apply mask for changing API needs. When abit stable apply final mask to actual code
		function pack ( modelOrig, mode ) {
			var model   = angular.copy( modelOrig );
			var rawTags = angular.copy( model.tags );

			if ( mode === 'save' ) {
				model.templateId = apiService.generateUUID();
			}

			model.name       = model.template.name.trim() || 'Untitled Template';
			model.creator.id = model.creator.id.toString();
			// api throws error when id is not set
			model.id         = model.templateId;
			// first element in tag array need to be transfered to type
			model.types      = rawTags[ 0 ].children.map( typeMapper );
			modelOrig.types  = model.types;

			model.templateAttachments = ( model.templateAttachments || [] ).map( attachmentsMapper );
			// both are needed by the api
			delete model.locked;
			delete model.version;
			// once type has been copied need to remove
			rawTags.splice( rawTags.indexOf( rawTags[ 0 ] ), 1 );
			// change format to fit reverted requirements
			model.tags   = rawTags.map( tagMapper );
			// mapping would not be needed when api per resource is provided
			model.groups = model.groups.map( groupMapper );
			// api shift to update mode when UUID is provided
			delete model.templateId;
			delete model.template;

			rubricMapper( model );

			modelOrig.templateId = model.id;

			if ( !model.formula || model.formula === '' ) {
				delete model.formula;
			}

			return model;
		}

		return {
			'pack' : pack
		};
	}

	angular
		.module( 'app.templates' )
		.factory( 'saveTemplateMask', saveTemplateMask );

	saveTemplateMask.$inject = [ 'apiService' ];
} )( );
